import PropTypes from 'prop-types';
import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import _ from 'lodash';

import { translate as t } from '../../lib/I18n';
import { makeUrl } from '../../lib/APIClient';
import OrderService from '../../services/OrderService';

import Order from '../../records/Order';
import OrderTrip from '../../records/order/Trip';

import BaseModal from '../general/BaseModal';
import Icon from '../general/Icon';
import FareStations from './FareStations';
import OrderTicket from './Ticket';
import PureRenderComponent from '../PureRenderComponent';

function _ticketUrl (order, ticket) {
    return makeUrl(OrderService.getTicketUrl(order, ticket));
}

class DownloadTicketsModal extends PureRenderComponent {

    static propTypes = {
        order: PropTypes.instanceOf(Order).isRequired,
        orderTrip: PropTypes.instanceOf(OrderTrip).isRequired,
        onClose: PropTypes.func
    };

    static defaultProps = {
        onClose: _.noop
    };

    _getFareName(fare) {
        return (<FareStations origin={ fare.origin } destination={ fare.destination } isReturn={ fare.isReturn() } />);
    }

    render() {
        const { order, orderTrip, onClose } = this.props;

        return (
            <BaseModal
                onClose={ onClose }
                hideContinue
                titleText="order.summary.download.title"
                className="modal--xs download-tickets__modal">
                {
                    orderTrip.getJourneyFares().map((tripFare) => (
                        <div key={ tripFare.fareId } className="box margin-top--sm padding--horiz">
                            <Row className="padding-top--sm padding-bottom--sm padding--horiz-sm">
                                <Col className="fare__name">
                                    { this._getFareName(tripFare) }
                                </Col>
                            </Row>
                            <div className="ticket__downloads margin-bottom--sm">
                                { tripFare.tickets.map((ticket) => (
                                    <Row key={ ticket.id }>
                                        <Col xs={ 9 }><OrderTicket ticket={ ticket } /></Col>
                                        <Col xs={ 3 } className="text-right">
                                            { ticket.isRefunded && 'Refunded' }
                                            { !ticket.isRefunded && ticket.attachment && (
                                                <Button className="btn btn-link">
                                                    <Icon icon="document" />
                                                    <a href={ _ticketUrl(order, ticket) } download={ `${t('app.owner')} ${t('order.summary.download.ticketName', { id: ticket.id })}` }>
                                                        { t('order.summary.download') }
                                                    </a>
                                                </Button>
                                            ) }
                                            { !ticket.isRefunded && !ticket.attachment && t('order.summary.download.generating') }
                                        </Col>
                                    </Row>)) }
                            </div>
                        </div>
                    ))
                }
            </BaseModal>
        );
    }
}

export default DownloadTicketsModal;
